import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { getListSaga } from "../base/request/get";

import { SagaActionParams, SagaGenericParams } from "../base/types/saga";
import {
  BankAccountDto,
  CityDto,
  CountryDto,
  DistrictDto,
  NeighbourhoodDto,
  PaymentTypeDto,
  SubDistrictDto,
} from "./type";
export const getCountries = createAction(
  "GET_COUNTRIES",
  ({ payload }: SagaActionParams<CountryDto[]>) => ({
    payload,
    url: "/api/system/countries",
  })
);
export const getCities = createAction(
  "GET_CITIES",
  ({ payload, id }: SagaActionParams<CityDto[]>) => ({
    payload,
    url: "/api/system/cities/?countyId=" + id,
  })
);
export const getDistricts = createAction(
  "GET_DISTRICTS",
  ({ payload, id }: SagaActionParams<DistrictDto[]>) => ({
    payload,
    url: "/api/system/districts?CityId=" + id,
  })
);
export const getPaymentTypes = createAction(
  "GET_PAYMENT_TYPES",
  ({ payload }: SagaActionParams<PaymentTypeDto[]>) => ({
    payload,
    url: "/api/system/paymenttypes",
  })
);
export const getSubDistricts = createAction(
  "GET_SUBDISTRICTS",
  ({ payload, id }: SagaActionParams<SubDistrictDto[]>) => ({
    payload,
    url: "/api/system/subdistricts?DistrictId=" + id,
  })
);
export const getNeighbourhoods = createAction(
  "GET_NEIGHBOURHOOD",
  ({ payload, id }: SagaActionParams<NeighbourhoodDto[]>) => ({
    payload,
    url: "/api/system/neighbourhoods?SubDistrictId=" + id,
  })
);
export const getBankaccounts = createAction(
  "GET_BANK_ACCOUNT",
  ({ payload }: SagaActionParams<BankAccountDto[]>) => ({
    payload,
    url: "/api/system/bankaccounts",
  })
);
const systemSaga = [
  takeLatest(
    getBankaccounts.toString(),
    (payload: SagaGenericParams<BankAccountDto[]>) =>
      getListSaga<BankAccountDto[]>(payload)
  ),
  takeLatest(
    getPaymentTypes.toString(),
    (payload: SagaGenericParams<PaymentTypeDto[]>) =>
      getListSaga<PaymentTypeDto[]>(payload)
  ),
  takeLatest(
    getCountries.toString(),
    (payload: SagaGenericParams<CountryDto[]>) =>
      getListSaga<CountryDto[]>(payload)
  ),
  takeLatest(getCities.toString(), (payload: SagaGenericParams<CityDto[]>) =>
    getListSaga<CityDto[]>(payload)
  ),
  takeLatest(
    getDistricts.toString(),
    (payload: SagaGenericParams<DistrictDto[]>) =>
      getListSaga<DistrictDto[]>(payload)
  ),
  takeLatest(
    getSubDistricts.toString(),
    (payload: SagaGenericParams<SubDistrictDto[]>) =>
      getListSaga<SubDistrictDto[]>(payload)
  ),
  takeLatest(
    getNeighbourhoods.toString(),
    (payload: SagaGenericParams<NeighbourhoodDto[]>) =>
      getListSaga<NeighbourhoodDto[]>(payload)
  ),
];

export default systemSaga;
